import { Editor } from '@tiptap/react';
import { TFunction } from 'i18next';
import {
  Bold,
  Italic,
  Link,
  ListChecks,
  ListOrdered,
  Strikethrough,
  Underline,
  type LucideIcon,
} from 'lucide-react';

export type ActionType = {
  type: 'format' | 'link';
  execute: (editor: Editor) => void;
};

type MenuItemConfig = {
  icon: LucideIcon;
  label: string;
  action: ActionType;
  isActive: (editor: Editor) => boolean;
};

type MenuConfig = {
  formatting: MenuItemConfig[];
  lists: MenuItemConfig[];
  links: MenuItemConfig[];
};

export const BubbleMenuConfig = (t: TFunction<string>): MenuConfig => ({
  formatting: [
    {
      icon: Bold,
      label: t('bold'),
      action: {
        type: 'format',
        execute: (editor) => editor.chain().focus().toggleBold().run(),
      },
      isActive: (editor) => editor.isActive('bold'),
    },
    {
      icon: Italic,
      label: t('italic'),
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleItalic().run(),
      },
      isActive: (editor) => editor.isActive('italic'),
    },
    {
      icon: Underline,
      label: t('underline'),
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleUnderline().run(),
      },
      isActive: (editor) => editor.isActive('underline'),
    },
    {
      icon: Strikethrough,
      label: t('strike'),
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleStrike().run(),
      },
      isActive: (editor) => editor.isActive('strike'),
    },
  ],
  lists: [
    {
      icon: ListChecks,
      label: t('bullet_list'),
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleBulletList().run(),
      },
      isActive: (editor) => editor.isActive('bulletList'),
    },
    {
      icon: ListOrdered,
      label: 'Ordered List',
      action: {
        type: 'format',
        execute: (editor: Editor) => editor.chain().focus().toggleOrderedList().run(),
      },
      isActive: (editor) => editor.isActive('orderedList'),
    },
  ],
  links: [
    {
      icon: Link,
      label: t('link'),
      action: {
        type: 'link',
        execute: () => {},
      },
      isActive: (editor) => editor.isActive('link'),
    },
  ],
});
